module.exports = __webpack_public_path__ + "static/media/cancel1.4a5081ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cancel1.png
// module id = 1994
// module chunks = 0